import React from "react";

/**
 * Renders the top content of a login form.
 *
 * @param {Object} title - The title of the form.
 * @param {string} desc - The description of the form.
 * @param {string} titleClass - Additional CSS class for the title.
 * @return {JSX.Element} The top content JSX element.
 */
const LoginFormTopContent = ({ title, desc, titleClass = "" }) => {
  return (
    <div className="flex flex-col gap-4">
      {title && (
        <h2
          className={`text-center text-[24px] font-semibold leading-[normal] text-primary ${titleClass}`}
        >
          {title}
        </h2>
      )}
      {desc && (
        <p className="text-center text-[14px] font-medium text-black">{desc}</p>
      )}
    </div>
  );
};

export default LoginFormTopContent;
